import type { LookupAssetSpecsResponse } from '@/features/assets/types/lookupAssetSpecs';

/** Sample PDFs so Open / Download work in the browser during UI testing. */
const SAMPLE_PDF =
  'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf';
const SAMPLE_INSTALL_PDF =
  'https://www.africau.edu/images/default/sample.pdf';

export function isMockLookupAssetSpecsEnabled(): boolean {
  return import.meta.env.VITE_MOCK_LOOKUP_ASSET_SPECS === 'true';
}

/** Mirrors a successful `lookup-asset-specs` asset_id response (rule match + related). */
export const MOCK_LOOKUP_ASSET_SPECS_RESPONSE: LookupAssetSpecsResponse = {
  success: true,
  source: 'rule',
  spec_sheet_id: 'aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee',
  rule_id: 'rule-uuid',
  related_spec_sheet_ids: ['sibling-uuid-1', 'sibling-uuid-2'],
  asset_updated: true,
  model_id: '50TCA04',
  message: undefined,
  primary_pdf: {
    id: 'aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee',
    document_type: 'product_data',
    manufacturer: 'Carrier',
    file_url: SAMPLE_PDF,
    product_family_codes: ['50', '50T'],
  },
  related_pdfs: [
    {
      id: 'sibling-uuid-1',
      document_type: 'installation_manual',
      manufacturer: 'Carrier',
      file_url: SAMPLE_INSTALL_PDF,
      product_family_codes: ['50'],
    },
  ],
};
